import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import ActionButton from "components/Buttons/ActionButton";
import useGlobalModal from "features/ModalManagement/hooks/useGlobalModal";
import useProject from "hooks/useProject";
import { usePersistStore } from "hooks/useStore";
import { useEffect } from "react";

import {
  PeopleOutlineOutlined,
  PlayCircleFilledRounded,
  PlaylistPlayOutlined,
  QuizOutlined,
} from "@mui/icons-material";
import { flexCentered } from "theme/base/flex";

export default function LegacyFeatureModal() {
  const { projectId } = useProject();
  const { setModalContent } = useGlobalModal();
  const { imported } = useProject();
  const { legacyFeaturesDismissed, setValue } = usePersistStore() as {
    legacyFeaturesDismissed: Record<string, boolean>;
    setValue: (key: string, value: Record<string, boolean>) => void;
  };

  useEffect(() => {
    if (imported && !legacyFeaturesDismissed[projectId]) {
      setModalContent(
        <Stack
          direction="column"
          spacing={2}
          sx={{ width: "100%", height: "100%", ...flexCentered }}
        >
          <Typography variant={"h6"}>
            Legacy Projects have the following features disabled.
          </Typography>
          <List sx={{ pb: 3 }}>
            <ListItem sx={{ p: 1 }}>
              <ListItemIcon>
                <QuizOutlined />
              </ListItemIcon>
              <ListItemText primary="Add / Update Scripts" />
            </ListItem>
            <ListItem sx={{ p: 1 }}>
              <ListItemIcon>
                <PeopleOutlineOutlined />
              </ListItemIcon>
              <ListItemText primary="Add / Update Participants" />
            </ListItem>
            <ListItem sx={{ p: 1 }}>
              <ListItemIcon>
                <PlaylistPlayOutlined />
              </ListItemIcon>
              <ListItemText primary="Add / Update Playlists" />
            </ListItem>
            <ListItem sx={{ p: 1 }}>
              <ListItemIcon>
                <PlayCircleFilledRounded />
              </ListItemIcon>
              <ListItemText primary="Upload Videos" />
            </ListItem>
          </List>
          <ActionButton
            sx={{ width: 200 }}
            onClick={() => {
              setValue("legacyFeaturesDismissed", {
                ...legacyFeaturesDismissed,
                [projectId]: true,
              });
              setModalContent(null);
            }}
          >
            Don't Show Again
          </ActionButton>
        </Stack>,
      );
    }
  }, [imported, legacyFeaturesDismissed]);

  return <></>;
}
